import { connect } from 'react-redux';
import { IState } from '../../store';
import { Dispatch } from 'redux';
import { setNewbuildingMvkIsWidgetOpenAction } from '../../store/newbuilding_mvk';
import {
  INewbuildingMVKStoreProps,
  INewbuildingMVKDisspatchProps,
  INewbuildingMVKOwnProps,
  NewbuildingMVK,
} from './newbuilding_mvk';

function mapStateToProps(state: IState): INewbuildingMVKStoreProps {
  return {
    isOpen: state.newbuildingMvk.isWidgetOpen,
    MVKData: state.newbuildingMvk.MVKData,
    offerId: state.offerData.offer.id,
    sectionId: state.newbuildingMvk.openedSectionId,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): INewbuildingMVKDisspatchProps {
  return {
    closeWidget: () => dispatch(setNewbuildingMvkIsWidgetOpenAction(false)),
  };
}

export const NewbuildingMVKContainer = connect<
  INewbuildingMVKStoreProps,
  INewbuildingMVKDisspatchProps,
  INewbuildingMVKOwnProps
>(mapStateToProps, mapDispatchToProps)(NewbuildingMVK);
